import { FormItem, MenuPresets } from '@framework/form';
import { yup } from '@framework/validation';
import React from 'react';
import { RichTextAdvancedInput } from '../../../../../inputs/rich-text-advanced/RichTextAdvancedInput';
import { RichTextAdvancedSchema } from '../../../../../inputs/rich-text-advanced/schema/RichTextAdvancedSchema';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { WidgetType } from '../../../Widget';
import { BaseLayoutColSpanInput } from '../../common/BaseLayoutColSpanInput';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { CommonGraphicWidgetConfigSchema } from '../common/CommonGraphicWidgetConfigSchema';
import { IParagraphWidget } from './IParagraphWidget';

export const ParagraphWidgetConfigSchema =
  CommonGraphicWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Paragraph).required(),
    body: RichTextAdvancedSchema.required()
      .label('Testo')
      .default(() => [
        {
          type: 'text' as const,
          text: null,
        },
      ]),
    label: RichTextAdvancedSchema.label('Etichetta').when(
      'layout.isTableColumn',
      {
        is: true,
        then: schema => schema.required(),
        otherwise: schema => schema.notRequired().strip(),
      },
    ),
  }) satisfies yup.ObjectSchema<IParagraphWidget>;

export interface IParagraphWidgetConfigComponentProps
  extends IWidgetComponentProps<IParagraphWidget> {}

export function ParagraphWidgetConfigComponent(
  props: IParagraphWidgetConfigComponentProps,
) {
  const options = getWidgetProps(props);

  return (
    <div>
      <BaseLayoutColSpanInput isTableColumn={options.isTableColumn} />

      {options.isTableColumn && (
        <FormItem name="label" label="Etichetta">
          <RichTextAdvancedInput
            name="label"
            rows={2}
            menus={MenuPresets.Minimal}
          />
        </FormItem>
      )}

      <FormItem name="body" label="Testo">
        <RichTextAdvancedInput
          name="body"
          menus={MenuPresets.Block}
          rows={10}
        />
      </FormItem>
    </div>
  );
}
